<template lang="pug">
  .login-page
    .wrapper.wrapper-full-page
      .full-page.login-page.section-image
        .content
          BContainer
            BCol.ml-auto.mr-auto(lg="4" md="6")
              LoginForm
        .full-page-background(:style="{ backgroundImage: `url(${backgroundImage})` }")
</template>

<script>
import LoginForm from '@/components/login/LoginForm'

export default {
  components: { LoginForm },
  computed: {
    backgroundImage: () => require('@/assets/img/background/background-login.jpg')
  }
}
</script>
